"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3PresignedUrl = void 0;
class S3PresignedUrl {
}
exports.S3PresignedUrl = S3PresignedUrl;
//# sourceMappingURL=s3.js.map